import {authenticationReducers} from "./security/authentication.reducers";
import {IAppState} from "../state/app.state";
import {Action, ActionReducerMap, combineReducers} from "@ngrx/store";
import {authenticatedUserReducers} from "./security/authenticated-user.reducers";
import {reportInsightsAvgPriceReducers, reportInsightsBestItemsReducers, reportInsightsFillRateReducers, reportInsightsKeyIndicatorsReducers, reportInsightsKeyIndicatorsSupplierReducers, reportInsightsMarketShareReducers, reportInsightsProfitabilityReducers, reportInsightsPromoReducers, reportInsightsServiceLevelReducers, reportInsightsStockRotationReducers} from "./reports/insights.reducers";
import {taskDetailReducers, tasksListReducers} from "./tasks/tasks.reducers";
import {accountingReducers} from "./accounting/accounting.reducers";
import {partnersReducers} from "./partners/partners.reducers";
import {accountOperationsReducers} from "./accounting/account-operations.reducers";
import {currentResourceReducers, resourcesReducers} from "./resources/resources.reducers";
import {applicationParametersReducers, languageReducers} from "./application-parameters/application-parameters.reducers";
import {osaScanningReducers} from "./osa/osa-scanning.reducers";
import {reportPerformanceComparativeNomenclatureReducers, reportPerformanceComparativeStoresReducers, reportPerformanceDynamicsReducers, reportPerformanceTotalReducers} from "./reports/performance.reducers";
import {mdmReducers} from "./mdm/mdm.reducers";
import {displayModeReducers} from "./system/display-mode.reducers";
import {viewElementsReducers} from "./system/view-elements.reducers";
import {routerReducer} from "@ngrx/router-store";
import {configurationReducers} from "./configuration/configuration.reducers";
import {topPanelReducers} from "./top-panel/top-panel.reducers";
import {marketplaceReducers} from "./marketplace/marketplace.reducers";

//редьюсеры модуля insights
export const reportInsightsReducers = combineReducers({
  reportFillRate: reportInsightsFillRateReducers,
  reportStockRotation: reportInsightsStockRotationReducers,
  reportMarketShare: reportInsightsMarketShareReducers,
  reportKeyIndicators: reportInsightsKeyIndicatorsReducers,
  reportProfitability: reportInsightsProfitabilityReducers,
  reportPromo: reportInsightsPromoReducers,
  reportKeyIndicatorsSuppliers: reportInsightsKeyIndicatorsSupplierReducers,
  reportBestItems: reportInsightsBestItemsReducers,
  reportAvgPrice:reportInsightsAvgPriceReducers,
  reportServiceLevel: reportInsightsServiceLevelReducers

});

export const reportPerformanceReducers = combineReducers({
  reportTotal: reportPerformanceTotalReducers,
  reportComparativeStores: reportPerformanceComparativeStoresReducers,
  reportComparativeNomenclature: reportPerformanceComparativeNomenclatureReducers,
  reportDynamics: reportPerformanceDynamicsReducers
  }

);

//редьюсеры вообще отчетов
export const reportsReducers =combineReducers({
  insights: reportInsightsReducers,
  performance: reportPerformanceReducers
});


export const tasksReducers = combineReducers( {
  tasksList: tasksListReducers,
  taskDetail: taskDetailReducers
});


export const osaReportsReducers = combineReducers( {
  scanning: osaScanningReducers
});

export const osaReducers = combineReducers({
  reports: osaReportsReducers

});

//глобальные редьюсеры
export const appReducers: ActionReducerMap<IAppState, Action> = {
  configuration: configurationReducers,
  authentication: authenticationReducers,
  authenticatedUser: authenticatedUserReducers,
  reports: reportsReducers,
  tasks: tasksReducers,
  accounting: accountingReducers,
  partners: partnersReducers,
  accountOperations: accountOperationsReducers,
  resources:resourcesReducers,
  currentResource: currentResourceReducers,
  language:languageReducers,
  osa: osaReducers,

  applicationParameters: applicationParametersReducers,

  mdm: mdmReducers,
  displayMode: displayModeReducers,
  viewElements: viewElementsReducers,
  topPanel: topPanelReducers,
  router: routerReducer,

  marketplace: marketplaceReducers

};
